import { effects } from 'redux-saga'

import { LOAD_INVOICES } from '../../modules/invoice'
import load from './load'

export default function* invoiceSaga({ invocation }) {
  yield [
    effects.takeEvery(LOAD_INVOICES, load, invocation),
  ]
}

export const sagas = {
  load,
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/redux/sagas/invoice/index.js